var strNotNull = function(str) {
  return typeof str === 'string' && str !== ''
}

// 获取指定时间，默认返回当前时间，如果不想有默认值，mode=true
export function getDate(str, mode) {
  mode = mode !== false
  return strNotNull(str) ? new Date(str) : mode ? new Date() : undefined
}

// 获取今天短日期 yyyy-mm-dd
export function getStrDate() {
  var date = new Date()
  return trimStrDate(date)
}

// 获取长日期 yyyy-mm-dd hh:mi:ss
export function getLongStrDate() {
  var date = new Date()
  return trimStrDate(date) + ' ' + trimStrTime(date)
}

// 计算两个字符日期相差天数
export function getDiffDays(startDate, endDate) {
  let start = new Date(startDate.replace(/-/g, '/'))
  let end = new Date(endDate.replace(/-/g, '/'))
  if(start != 'Invalid Date' && end != 'Invalid Date') {
    return Math.abs((start - end) / (1000 * 60 * 60 * 24))
  }
  return ''
}

// date -> hh:mi
export function trimStrTimehm(date) {
  if(!date) {
    date = new Date()
  }
  var d = trimStrDate(date)
  var h = date.getHours()
  var mi = date.getMinutes()
  return d + ' ' + (h < 10 ? '0' + h : h) + ':' + (mi < 10 ? '0' + mi : mi)
}

/*
 * 根据出生日期算出年龄
 * strEndDate 以此时间为结束时间，不传默认以当前时间计算
 */
export function jsGetAge(strBirthday, strEndDate) {
  var returnAge
  var strBirthdayArr = strBirthday.split('-')
  var birthYear = strBirthdayArr[0]
  var birthMonth = strBirthdayArr[1]
  var birthDay = strBirthdayArr[2]

  var nowYear,
    nowMonth,
    nowDay

  if(strEndDate) {
    var strEndDateArr = strEndDate.split('-')
    nowYear = strEndDateArr[0]
    nowMonth = strEndDateArr[1]
    nowDay = strEndDateArr[2]
  } else {
    var d = new Date()
    nowYear = d.getFullYear()
    nowMonth = d.getMonth() + 1
    nowDay = d.getDate()
  }

  if(nowYear === birthYear) {
    returnAge = 0 // 同年 则为0岁
  } else {
    var ageDiff = nowYear - birthYear // 年之差
    if(ageDiff > 0) {
      if(nowMonth === birthMonth) {
        var dayDiff = nowDay - birthDay // 日之差
        if(dayDiff < 0) {
          returnAge = ageDiff - 1
        } else {
          returnAge = ageDiff
        }
      } else {
        var monthDiff = nowMonth - birthMonth // 月之差
        if(monthDiff < 0) {
          returnAge = ageDiff - 1
        } else {
          returnAge = ageDiff
        }
      }
    } else {
      returnAge = -1 // 返回-1 表示出生日期输入错误 晚于今天
    }
  }

  return returnAge // 返回周岁年龄
}

/**
 * 根据出生日期算出年龄年、月、日之间的差异更加准备
 */
export function jsGetAgeaccurate(strBirthday, strEndDate) {
  // 获取当前日期
  const currentDate = strEndDate ? new Date(strEndDate) : new Date();
  // 设置出生日期
  const birthDate = new Date(strBirthday);
  // 计算年龄差异（以年为单位）
  let ageDiff = currentDate.getFullYear() - birthDate.getFullYear();
  // 如果当前月份小于出生日期的月份，或者当前月份等于出生日期的月份但是当前日期小于出生日期的日期，则年龄减少1
  if(
    currentDate.getMonth() < birthDate.getMonth() ||
    (currentDate.getMonth() === birthDate.getMonth() && currentDate.getDate() < birthDate.getDate())
  ) {
    ageDiff--;
  }
  // 计算天数差异
  const dayDiff = Math.floor((currentDate - birthDate) / (1000 * 60 * 60 * 24));
  // 将年龄差异转换为带小数的年龄
  const age = (dayDiff / 365).toFixed(4);
  // console.log('age',age)
  return age;
}

/**
 * 根据身份证号 提取出年月日 dddd-dd-dd的格式
 *
 */
export function extractBirthdate(idNumber) {
  var year = idNumber.substring(6, 10);
  var month = idNumber.substring(10, 12);
  var day = idNumber.substring(12, 14);
  var birthdate = year + "-" + month + "-" + day;

  return birthdate;
}

// 根据年龄判断出乘客类型
export function typeage(age) {
  let psgType
  if(age == 'NaN') {
    psgType = 1// 成人
  } else if(age > 2 && age <= 12) {
    psgType = 2// 儿童
  } else if(age < 2) {
    psgType = 3// 婴儿
  } else if(age > 12) {
    psgType = 1// 成人
  }
  return psgType
}


// 计算两个字符日期相隔小时
export function getDiffHours(startDate, endDate) {
  var s =
    new Date(endDate.replace(/-/g, '/')) -
    new Date(startDate.replace(/-/g, '/'))
  var days = s / 3600000
  return parseFloat(days.toFixed(2))
}

// 计算两个字符日期相隔小时
export function getDiffHour(startDate, endDate) {
  if(startDate && endDate) {
    let start = new Date(startDate).getTime()
    let end = new Date(endDate).getTime()
    if(start != 'Invalid Date' && end != 'Invalid Date') {
      return (Math.abs((start - end) / (1000 * 60 * 60))).toFixed(1)
    }
  }
}

//计算两个字符日期相隔分钟
export function getDiffMinutes(startDate, endDate) {
  var time = startDate.split(' '),
    time_e = endDate.split(' '),
    year = new Date().getFullYear()

  if(time[0].length != 10) {
    startDate = year + '-' + startDate
  }

  if(time_e[0].length != 10) {
    endDate = year + '-' + endDate
  }

  var s = new Date(endDate.replace(/-/g, '/')) - new Date(startDate.replace(/-/g, '/'))
  var days = s / 60000
  return parseFloat(days.toFixed(2))
}

// 比较两个日期的大小,返回较大(flag==true)/较小(flag==false)的日期
export function getBigDate(d1, d2, flag) {
  var s = d1 > d2
  if(flag === s) {
    return d1
  } else {
    return d2
  }
}

// 比较两个字符日期d1,d2大小,若d1大于或等于d2为true,反则为false
export function compareDate(d1, d2) {
  return d1 > d2
}

// 通过字符日期获取星期几(int类型)
export function getWeekInt(date) {
  if(!date) return
  date = date.replace(/-/g, '/')
  var arr = date.split('/') // 日期为输入日期，格式为 2013-3-10
  var ssdate = new Date(arr[0], parseInt(arr[1] - 1), arr[2])
  return ssdate.getDay() // 就是你要的星期几
}

// 通过字符日期获取星期几(周*)
export function getWeekZhou(date) {
  var weekInt = getWeekInt(date)
  if(weekInt === 1) return '周一'
  if(weekInt === 2) return '周二'
  if(weekInt === 3) return '周三'
  if(weekInt === 4) return '周四'
  if(weekInt === 5) return '周五'
  if(weekInt === 6) return '周六'
  if(weekInt === 0) return '周日'
}

// 获取当前日期相对n天的字符日期    正数延后，负数推前
export function getRelativeDate(pro) {
  if(!pro) pro = 0
  var date = new Date()
  var time = date.getTime() + pro * 86400000
  return trimStrDate(new Date(time))
}

// 获取指定字符日期 n天之后的日期字符串     正数延后，负数推前
export function getPreStrDate(dateStr, pro) {
  if(!pro) pro = 0
  var date = getDate(dateStr)
  var time = date.getTime() + pro * 86400000
  return trimStrDate(new Date(time))
}

// time  获取指定字符日期 n小时之后的日期字符串     正数延后，负数推前
export function getPreStrTime(dateStr, pro) {
  if(!pro) pro = 0
  var date = getDate(dateStr)
  var time = date.getTime() + pro * 3600000
  date = new Date(time)
  return trimStrDate(date) + ' ' + trimStrTime(date)
}

// date ->  yyyy-mm-dd
export function trimStrDate(date) {
  var y = date.getFullYear()
  var m = date.getMonth() + 1
  var d = date.getDate()
  return y + '-' + (m < 10 ? '0' + m : m) + '-' + (d < 10 ? '0' + d : d)
}

// date -> hh:mi:ss
export function trimStrTime(date) {
  var h = date.getHours()
  var mi = date.getMinutes()
  var s = date.getSeconds()
  return (
    (h < 10 ? '0' + h : h) +
    ':' +
    (mi < 10 ? '0' + mi : mi) +
    ':' +
    (s < 10 ? '0' + s : s)
  )
}

/**
 * 获取当前时间
 * @param {string} strTime 传入时间   strTime时间（new Date()或new Date(2017-08-30)或new Date(2017,08,30)）
 * @param {Number} num 传入天数  num 当前时间+num天 num为负数 减天数
 * @return {Object} obj
 * 返回值obj.week 返回 当前传入时间的星期 例：‘周三’
 * 返回值obj.monDay 返回 例 ：08月30日 格式日期
 * 返回值obj.monDay2 返回 例 ：08-30 格式日期
 * 返回值obj.hm 返回 例 ：12:22 格式日期
 * 返回值obj.monDayWeek 例：08月08日（周二）
 * 返回值obj.date  年-月-日
 * 返回值obj.date2  年，月，日
 */
export const formatDate = (strTime = new Date(), num = 0) => {
  if(!strTime) return ''

  if(typeof strTime === 'string') {
    strTime = strTime.replace(/-/g, '/')
  }

  var obj = {}
  var dat = new Date(strTime)
  dat = dat.getTime() + 24 * 60 * 60 * 1000 * num
  dat = new Date(dat)
  var m = dat.getMonth() + 1
  var d = dat.getDate()
  var w = dat.getDay()
  var h = dat.getHours()
  var mins = dat.getMinutes()
  var s = dat.getSeconds()
  var arr = ['日', '一', '二', '三', '四', '五', '六']
  if(d < 10) {
    d = '0' + d
  }
  if(m < 10) {
    m = '0' + m
  }
  if(mins < 10) {
    mins = '0' + mins
  }
  if(h < 10) {
    h = '0' + h
  }
  obj.date = dat.getFullYear() + '-' + m + '-' + d
  if(obj.date === getDateMing(new Date(), 0)) {
    obj.week = '今天'
  } else if(obj.date === getDateMing(new Date(), 1)) {
    obj.week = '明天'
  } else if(obj.date === getDateMing(new Date(), 2)) {
    obj.week = '后天'
  } else if(w >= 0) {
    obj.week = '周' + arr[w]
  }
  obj.d = d                                           //日 02
  obj.month = m                                         //月 03
  obj.h = h                                             //小时 12
  obj.mins = mins                                       //分钟 04
  obj.monDay2 = m + '-' + d                           //月日 02-03
  obj.monDay = m + '月' + d + '日'                    //02月03日
  obj.monDayWeek = obj.monDay + '(' + obj.week + ')'  //02月03日 (周二)
  obj.hm = h + ':' + mins                             //时分 02：36
  obj.hms = h + ':' + mins + ':' + s                      //时分 02：36 ：00
  obj.date2 = dat.getFullYear() + ',' + m + ',' + d   //2020,02,03
  obj.date3 = dat.getFullYear() + '/' + m + '/' + d   //2020/02/03
  obj.datetime = dat                                    // Mon Jan 04 2021 15:33:32 GMT+0800 (中国标准时间)
  obj.datehm = obj.date + ' ' + obj.hm                      //2020-02-03 05:12
  obj.datehms = obj.date + ' ' + obj.hms                     //2020-02-03 05:12:00
  return obj
}

const getDateMing = (strTime, num) => {
  var dat = new Date(strTime)
  !num && (num = 0)
  dat = dat.getTime() + 24 * 60 * 60 * 1000 * num
  dat = new Date(dat)
  var y = dat.getFullYear()
  var m = dat.getMonth() + 1
  var d = dat.getDate()
  if(d < 10) {
    d = '0' + d
  }
  if(m < 10) {
    m = '0' + m
  }
  return y + '-' + m + '-' + d
}

/**
 * 获取日期天数差值
 * @param {string | Date} prev 前一天的日期 '2018-08-18' | new Date(2018,8,18)
 * @param {string | Date} next 后一天的日期 '2018-08-28' | new Date(2018,8,28)
 * @param {Number} num num = 0纯粹的差值,不传这两天包含在内 （用于火车票）
 * @return {Number} 差值
 */
export const dateDiff = (prev, next, num) => {
  if(!prev || !next) {
    return
  }
  const _diff = function(now, date) {
    return (now.getTime() - date.getTime()) / (24 * 60 * 60 * 1000)
  }
  var now = new Date(next)
  var date = new Date(prev)
  var diff = _diff(now, date)
  if(num === 0) {
    return diff
  } else {
    return diff + 1
  }
}

/**
 * 获取前后几小时的日期
 * @param {string} dat YY-MM-DD hh:mm:ss 2018-01-02 05:15
 * @param {Number} num 差值 正数或负数            5
 * @return {Number} YY-MM-DD hh:mm:ss 2018-01-02 10:15:00
 */
export const getTimeByNum = function(dat, num) {
  if(!num) num = 0
  var arr = dat && dat.split(' ')
  var ymd = arr[0].split('-')
  var y = parseInt(ymd[0])
  var m = ymd[1] - 0
  var d = parseInt(ymd[2])
  var sfm = arr[1].split(':')
  var s = parseInt(sfm[0])

  var f = parseInt(sfm[1])

  var miao = sfm.length === 3 ? parseInt(sfm[2]) : 0

  var date = new Date(y, m, d, s, f, miao)
  let time = date.getTime() + (num - 0) * 3600000
  date = new Date(time)
  return trimStrDate(date) + ' ' + trimStrTime(date)
}

//获取指定日期 前后三天的日期数据 用于显示一周的时间
export const getOneWeek = function(date) {
  var enday = formatDate(date || new Date(), 7).date
  var nday = formatDate(new Date()).date
  var arr = []
  var n = 3
  var m = 3
  for(var i = -n; i <= m; i++) {
    var d = formatDate(date, i).date
    var w = formatDate(d)
    if(d < nday) {
      n -= 1
      m += 1
    } else if(d > enday) {
      n += 1
      m -= 1
    } else {
      arr.push({
        'date': d,
        'shortDate': w.monDay2,
        'week': w.week
      })
    }
  }
  return arr
}

// 秒 转 分钟  例如：600 -> 10
export const secondsToMins = function(seconds) {
  seconds = parseInt(seconds)
  return parseInt(seconds / 60)
}

export const getTimeState = function() {
  // 获取当前时间
  let timeNow = new Date()
  // 获取当前小时
  let hours = timeNow.getHours()
  // 设置默认文字
  let state = ''
  // 判断当前时间段
  if(hours >= 0 && hours <= 10) {
    state = '早上'
  } else if(hours > 10 && hours <= 14) {
    state = '中午'
  } else if(hours > 14 && hours <= 18) {
    state = '下午'
  } else if(hours > 18 && hours <= 24) {
    state = '晚上'
  }
  return state
}

export const duration = function(info) {
  console.log(info)
  let time1 = info.departTime
  let time2 = info.arriveTime
  const [hour1, minute1] = time1.split(':').map(Number);
  const [hour2, minute2] = time2.split(':').map(Number);

  let totalMinutes1 = hour1 * 60 + minute1;
  let totalMinutes2 = hour2 * 60 + minute2;

  // 如果时间2在时间1之前，加上一天的分钟数
  if(totalMinutes2 < totalMinutes1) {
    totalMinutes2 += 24 * 60;
  }
  let differenceMinutes = totalMinutes2 - totalMinutes1;
  const hours = Math.floor(differenceMinutes / 60);
  const minutes = differenceMinutes % 60;
  // 格式化结果
  const formattedTimeDifference = `${hours}h${minutes}m`;
  return formattedTimeDifference;
}
